import * as React from "react";
import {Checkbox, CheckboxProps} from "@bizform/primereact/components/checkbox/Checkbox";
import {
    ComponentCategory,
    ComponentElementManifest,
    ComponentElementProperty
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {Static} from "@bizform/type/decorator/Static.decorator";
import {
    BaseStateModel,
    ComponentElement,
    ComponentElementDisplayMode,
    ComponentElementStatic,
    ComponentEventType
} from "@bizform/type/model/component_element/ComponentElement.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {DomAttribute} from "@bizform/type/model/dom/DomAttribute.model";
import {ComponentHelper, Debug} from "@bizform/helper/dist/js/bizflow/helper.min";
import {
    ComponentElementClass,
    GridActionService,
    ReactComponentElementInit
} from "@bizform/core/dist/js/bizflow/core.min";
import {AbstractComponentElement} from "../bf_component/AbstractComponentElement";


type Props = CheckboxProps & {
};

type State = BaseStateModel & {
    // attribute
    style?: object;
    className?: string;
    checked?: boolean;
    pk?: string;
    selectionAction?: any;
    deselectionAction?: any;

    // event
    onChange?(e: ComponentEventType): void;
};

/**
 * Checkbox for Grid Repeated Container
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
@ComponentElementClass()
@Static<ComponentElementStatic<string>>()
export class BfGridRepeatZCheckbox extends AbstractComponentElement<Props, State> {
    static readonly pluginType: string = PluginType.GRIDHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_EkDBanPcbSry2aKEeBzUBTc7HF6UtBt",
        category: ComponentCategory.INPUT,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "Checkbox for Repeated Data",
        description: "Checkbox for Repeated Data",
        icon: "",
        property: null
    };

    setProperty(property: ComponentElementProperty) {
        try {
            const newState = ComponentHelper.createStateWithProperties<State, null>(
                property,
                this);
            this.setState(newState);
        } catch (e) {
            Debug.console.error("setProperty", e);
        }
    }

    noDisplayInheritance() {
    }

    @ReactComponentElementInit(BfGridRepeatZCheckbox)
    static init(): ComponentElement<string> {
        return;
    }

    initDone(): void {
    }

    destroy(): void {
        this.destroyDone();
    }

    destroyDone(): void {
    }

    subscription(value: {checked: boolean, pk: string}) {
        this.setState({
            checked: value && value.checked === true,
            pk: value ? value.pk : null
        });
    }

    emitFormState(value: string, e?: MouseEvent): void {
    }

    onHasEpk() {
        this.setState({
            ...this.state,
            checked: true,
        });
    }

    /* for React */
    props: Props;
    state: State;

    private _checkbox: HTMLElement;

    constructor(props?: Props) {
        super(props);
        this.state = {};
        this._onChangeEvent = this._onChangeEvent.bind(this);
        this._setRef = this._setRef.bind(this);
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        Debug.console.error(error, errorInfo);
    }

    render(): React.ReactNode {
        if (!this.displayMode) {
            return null;
        } else {
            const attr = {
                [DomAttribute.GRIDCHECKBOX]: this.state.pk
            };
            return (
                <div className="w-100 h-100 m-0 p-0" {...attr}>
                    <Checkbox
                        {...attr}
                        ref={this._setRef}
                        inputId={this.elementId}
                        key={this.elementId}
                        checked={this.state.checked}
                        onChange={this._onChangeEvent}
                        style={this.state.style}
                        className={this.state.className}
                        disabled={this.displayMode !== ComponentElementDisplayMode.EDIT}
                    />
                </div>
            );
        }
    }

    private _onChangeEvent(e: any): void {
        this.setState({
            pk: this.state.pk,
            checked: e.checked
        });
        if (e.checked && this.state.selectionAction) {
            if (this.state.selectionAction.state) {
                this.emitFormState(this.state.selectionAction.state, e);
            }
            if (this.state.selectionAction.action) {
                GridActionService.callAction(this.applicationId, this.formId, this.state.selectionAction.action, this._checkbox, (this as any).___props);
            }
        }
        if (!e.checked && this.state.deselectionAction) {
            if (this.state.deselectionAction.state) {
                this.emitFormState(this.state.deselectionAction.state, e);
            }
            if (this.state.deselectionAction.action) {
                GridActionService.callAction(this.applicationId, this.formId, this.state.deselectionAction.action, this._checkbox, (this as any).___props);
            }
        }
    }

    private _setRef(ref) {
        if (ref) {
            this._checkbox = ref.element;
            this.readyComponent();
        }
    }
}
